// src/components/NotificationListener.js
import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase";

const NotificationListener = () => {
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
    //   console.log("📩 Notification reçue (foreground):", payload);

      if (payload.notification) {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon:  "/logo.png",
        });
      }
    });

    return () => unsubscribe();
  }, []);

  return null;
};

export default NotificationListener;
